export default __webpack_public_path__ + "static/media/pokedex-generation.0a53940f.png";